import * as React from "react";
import "../filters.scss";
import NumberBetweenFilter, {NumberBetweenFilterModel} from "./NumberBetweenFilter";
import {none, Option} from "ts-option";
import FilterButton from "../button/FilterButton";
import DropDownWrapper from "../../../../hiberUiKit/src/molecules/DropDownWrapper/DropDownWrapper";
import FilterButtons from "../FilterButtons";
import Filter from "../../../../model/workspace/Filter";
import NumberFilterModel from "../../../../model/workspace/NumberFilterModel";
import {default as NumberCompareFilter, NumberCompareFilterModel} from "./NumberCompareFilter";
import deepEqual = require("deep-equal");

interface IProps {
	filter: Filter;
	onRemove: (refreshData: boolean) => void;
	onChange: (filter: Filter) => void;
	isFilterConfigVisible?: boolean;
	isCollection?: boolean
}

interface IState {
	/**
	 * Selected radio button Id
	 */
	selectedRadioButtonId: NumberFilterType;

	value: Option<NumberFilterModel>

	isFilterConfigVisible: boolean
}

export default class NumberFilter extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);
		this.state = {
			selectedRadioButtonId: props.filter.values.map(v => (v as NumberFilterModelType).radioButtonId).orNull,
			isFilterConfigVisible: props.isFilterConfigVisible,
			value: none
		};

		this.onDateFilterSelect = this.onDateFilterSelect.bind(this);
		this.onDateFilterChange = this.onDateFilterChange.bind(this);
		this.onDone = this.onDone.bind(this);
		this.onCancel = this.onCancel.bind(this);
	}

	render() {
		const value = this.props.filter.values.orNull;
		let moreThanValue = none;
		let lessThanValue = none;
		let equalToValue = none;

		if (value instanceof NumberCompareFilterModel) {
			const castedValue = value as NumberCompareFilterModel;
			if (castedValue.radioButtonId === NumberFilterType.GreaterThan) {
				moreThanValue = this.props.filter.values as Option<NumberCompareFilterModel>;
			}
			else if (castedValue.radioButtonId === NumberFilterType.LessThan) {
				lessThanValue = this.props.filter.values as Option<NumberCompareFilterModel>;
			}
			else if (castedValue.radioButtonId === NumberFilterType.Equal) {
				equalToValue = this.props.filter.values as Option<NumberCompareFilterModel>;
			}
		}

		const betweenValue = value instanceof NumberBetweenFilterModel ?
			this.props.filter.values as Option<NumberBetweenFilterModel> : none;

		return (
			<div>
				<FilterButton filterName={this.props.filter.columnDefinition.label}
							  onRemove={() => this.props.onRemove(true)}
							  onClick={() => this.setState({isFilterConfigVisible: true})}
							  filterValue={this.props.filter.values.map(
								  v => (v as NumberFilterModelType).getDisplayValue()).orNull}
							  isDisabled={this.state.isFilterConfigVisible}/>
				{this.state.isFilterConfigVisible &&
				<DropDownWrapper width={"auto"} onOutsideClick={this.onCancel}>
					<div className={"c-filter_numbers"}>
						<div className={"c-filter-dates_options-container"}>
							<div className={"c-filter-dates_inputs"}>
								<div className={"c-filter-dates_inputs_row"}>
									<NumberCompareFilter value={moreThanValue}
														 onChange={this.onDateFilterChange}
														 selectedRadioButtonId={this.state.selectedRadioButtonId}
														 onSelectButton={this.onDateFilterSelect}
														 filterType={NumberFilterType.GreaterThan}/>
								</div>
								<div className={"c-filter-dates_inputs_row"}>
									<NumberCompareFilter value={lessThanValue}
														 onChange={this.onDateFilterChange}
														 selectedRadioButtonId={this.state.selectedRadioButtonId}
														 onSelectButton={this.onDateFilterSelect}
														 filterType={NumberFilterType.LessThan}/>
								</div>
								<div className={"c-filter-dates_inputs_row"}>
									<NumberCompareFilter value={equalToValue}
														 onChange={this.onDateFilterChange}
														 selectedRadioButtonId={this.state.selectedRadioButtonId}
														 onSelectButton={this.onDateFilterSelect}
														 filterType={NumberFilterType.Equal}/>
								</div>
								<div className={"c-filter-dates_inputs_row"}>
									<NumberBetweenFilter value={betweenValue}
														 onChange={this.onDateFilterChange}
														 selectedRadioButtonId={this.state.selectedRadioButtonId}
														 onSelectButton={this.onDateFilterSelect}/>
								</div>
							</div>
						</div>
					</div>
					<FilterButtons onCancel={this.onCancel}
								   onDone={this.onDone}
								   disabled={this.state.value.isEmpty}/>
				</DropDownWrapper>}
			</div>
		)
	}

	/**
	 * Overwrite selected radio button Id in state
	 * @param {string} filtersRadioButtonId
	 */
	onDateFilterSelect(filtersRadioButtonId: NumberFilterType) {
		this.setState({selectedRadioButtonId: filtersRadioButtonId, value: none});
	}

	onDateFilterChange(value: Option<NumberFilterModelType>) {
		this.setState({value});
	}

	onCancel() {
		this.setState({isFilterConfigVisible: false}, () => this.props.filter.values.isEmpty && this.props.onRemove(false));
	}

	onDone() {
		this.setState({isFilterConfigVisible: false},
			() => !this.isEqual(this.props.filter.values as Option<NumberFilterModelType>, this.state.value)
				&& this.props.onChange(this.props.filter.copy({
					values: this.state.value,
					type: this.state.selectedRadioButtonId
				})));
	}

	isEqual(value1: Option<NumberFilterModelType>, value2: Option<NumberFilterModelType>): boolean {
		return value1.map(
			v1 => value2.map(v2 => v1.radioButtonId == v2.radioButtonId && deepEqual(v1.toQueryJson(), v2.toQueryJson()))
				.getOrElse(false)).getOrElse(value2.isEmpty);
	}
}

export type NumberFilterModelType =
	NumberFilterModel
	| NumberBetweenFilterModel
	| NumberCompareFilterModel;

export enum NumberFilterType {
	GreaterThan = "GREATER_THAN",
	LessThan = "LESS_THAN",
	Equal = "EQUAL",
	Between = "BETWEEN"
}

export const NumberFilterTypeName = {
	[NumberFilterType.GreaterThan]: "Greater than",
	[NumberFilterType.LessThan]: "Less than",
	[NumberFilterType.Equal]: "Equal to",
	[NumberFilterType.Between]: "Between"
};
